import { Fragment } from "react";

/** "\n" 을 <br/> 로 — i18n 문구의 의도된 줄바꿈. 좁은 화면에서는 CSS 로 br 을 숨길 수 있게 className 부여. */
export function Lines({ text }: { text: string }) {
  const parts = text.split("\n");
  return (
    <>
      {parts.map((p, i) => (
        <Fragment key={i}>
          {/* br 앞 공백: 좁은 화면에서 br 을 숨겨도 단어가 붙지 않게. CJK 는 .ln-sp 를 숨겨 여분 공백 제거. */}
          {i > 0 ? <><span className="ln-sp"> </span><br className="ln" /></> : null}
          {p}
        </Fragment>
      ))}
    </>
  );
}
